import { appConfig } from '../../../config/customization';

const rowHeight = 40;

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    align: 'center'
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: rowHeight,
    flexShrink: 0
  },
  row: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: `1px solid ${appConfig.colors.accountTableUnderline}`,
    width: '100%',
    height: rowHeight,
    flexShrink: 0
  },
  rowItem: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
};
